import { memo } from "react";

import { FacebookIcon, InstagramIcon, ThreadsIcon, XIcon } from "./icons";

/**
 * FacilityBasicInfo: 施設基本情報（施設名 / メール / 電話 / SNS）
 * ゲスト側 app/frontend/guest/_shared/src/components/facility-info/FacilityBasicInfo.astro の逐語再現。
 */

type Props = {
	name: string;
	email?: string;
	tel?: string;
	hasSns?: boolean;
};

const snsLinkClass =
	"flex size-10 items-center justify-center rounded-lg transition-colors active:scale-95 hover:bg-zinc-50";

export const FacilityBasicInfo = memo(({ name, email, tel, hasSns = true }: Props) => {
	return (
		<div>
			<h3 className="mb-5 text-xl font-semibold text-zinc-800">施設情報</h3>
			<div className="flex flex-col gap-6">
				<div className="flex flex-col gap-1 laptop:flex-row laptop:items-center">
					<p className="text-base font-semibold text-zinc-800 laptop:w-36 laptop:shrink-0">施設名</p>
					<p className="text-base text-zinc-800">{name}</p>
				</div>
				{email && (
					<div className="flex flex-col gap-1 laptop:flex-row laptop:items-center">
						<p className="text-base font-semibold text-zinc-800 laptop:w-36 laptop:shrink-0">メール</p>
						<p className="text-base text-zinc-800">
							<a href={`mailto:${email}`} className="hover:underline">
								{email}
							</a>
						</p>
					</div>
				)}
				{tel && (
					<div className="flex flex-col gap-1 laptop:flex-row laptop:items-center">
						<p className="text-base font-semibold text-zinc-800 laptop:w-36 laptop:shrink-0">電話番号</p>
						<p className="text-base text-zinc-800">
							<a href={`tel:${tel}`} className="hover:underline">
								{tel}
							</a>
						</p>
					</div>
				)}
				{hasSns && (
					<div className="flex flex-col gap-1 laptop:flex-row laptop:items-center">
						<p className="text-base font-semibold text-zinc-800 laptop:w-36 laptop:shrink-0">SNS</p>
						<div className="-ml-1.5 flex items-center gap-1.5">
							{/* preview モックなのでクリック時にナビゲーションさせない。
							    href="#" だとページトップへジャンプするため button 要素に変更。 */}
							<button type="button" className={snsLinkClass} aria-label="X (Twitter)">
								<XIcon size={24} />
							</button>
							<button type="button" className={snsLinkClass} aria-label="Instagram">
								<InstagramIcon size={24} />
							</button>
							<button type="button" className={snsLinkClass} aria-label="Facebook">
								<FacebookIcon size={24} />
							</button>
							<button type="button" className={snsLinkClass} aria-label="Threads">
								<ThreadsIcon size={24} />
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
});

FacilityBasicInfo.displayName = "FacilityBasicInfo";
